export default __webpack_public_path__ + "static/media/spin.128b4cda.gif";